import { mainAdminSplitApi } from 'redux/store/mainSplitApi'

const roleApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserRoles: builder.query<string[], void>({
      query: () => '/roles'
    })
  })
})

export const { useGetUserRolesQuery } = roleApi
